import { createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a3adb45"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "load_bar_wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "load_bar" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "logo_wrapper" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "img_wrapper" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "logo_img",
    src: "/assets/img/logo.svg"
  })
], -1))
const _hoisted_7 = {
  key: 0,
  class: "header_title"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/assets/img/logout.svg" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "body flex mt-4"
}
const _hoisted_10 = { class: "body_content body_content_without_menu" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "body"
}
const _hoisted_13 = { class: "auth_wrapper content_wrapper" }
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = { class: "auth_text" }
const _hoisted_16 = ["disable"]
const _hoisted_17 = { class: "even_messages_wrapper" }
const _hoisted_18 = { class: "my-0" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "my-0" }
const _hoisted_21 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_page500 = _resolveComponent("page500")!
  const _component_v_input = _resolveComponent("v-input")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, _hoisted_3, 512), [
      [_vShow, _ctx.load]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.isAuth ? 'title_auth' : 'title_logo')
        }, [
          _hoisted_6,
          (!_ctx.isAuth)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$t('main.title')), 1))
            : _createCommentVNode("", true)
        ], 2),
        (_ctx.isAuth && !_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "exit mb-0",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.signOut && _ctx.signOut(...args)))
            }, [
              _hoisted_8,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('main.sign_out')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ], 512), [
      [_vShow, !_ctx.isLoading]
    ]),
    (_ctx.isAuth && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (!_ctx.isUpdating)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_11, [
                  _createVNode(_component_router_view)
                ], 512)), [
                  [_vShow, !_ctx.isShowInternalServerError]
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_page500, null, null, 512), [
              [_vShow, _ctx.isShowInternalServerError]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.isAuth && !_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("h1", _hoisted_14, _toDisplayString(_ctx.$t('main.sign_in')), 1),
            _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('main.sign_in_text')), 1),
            _createVNode(_component_v_input, {
              class: "mt-8",
              modelValue: _ctx.login,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.login) = $event)),
              label: _ctx.$t('main.login'),
              placeholder: _ctx.$t('main.login_placeholder'),
              inputType: 'text',
              errorText: _ctx.loginErrorText,
              height: "28",
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loginErrorText = '')),
              onPressEnter: _ctx.signIn,
              clearable: ""
            }, null, 8, ["modelValue", "label", "placeholder", "errorText", "onPressEnter"]),
            _createVNode(_component_v_input, {
              class: "mt-7",
              modelValue: _ctx.password,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.password) = $event)),
              label: _ctx.$t('main.password'),
              placeholder: _ctx.$t('main.password_placeholder'),
              errorText: _ctx.passwordErrorText,
              inputType: _ctx.passwordInputType,
              onChangeType: _ctx.changeType,
              height: "28",
              onPressEnter: _ctx.signIn,
              password: "",
              onFocus: _cache[4] || (_cache[4] = ($event: any) => (_ctx.passwordErrorText = ''))
            }, null, 8, ["modelValue", "label", "placeholder", "errorText", "inputType", "onChangeType", "onPressEnter"]),
            _createElementVNode("button", {
              class: _normalizeClass(_ctx.isLoginButtonDisable ? 'auth_button disable_button' : 'auth_button'),
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.signIn && _ctx.signIn(...args))),
              disable: _ctx.isLoginButtonDisable
            }, _toDisplayString(_ctx.$t('main.sign_in_button')), 11, _hoisted_16)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "error",
          key: error
        }, [
          _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t(error)), 1),
          _createElementVNode("img", {
            class: "error_close",
            src: "/assets/img/close-red.svg",
            onClick: ($event: any) => (_ctx.closeError(error))
          }, null, 8, _hoisted_19)
        ]))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.successMessages, (successMessage) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "success",
          key: successMessage
        }, [
          _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.$t(successMessage)), 1),
          _createElementVNode("img", {
            class: "success_close",
            src: "/assets/img/close-green.svg",
            onClick: ($event: any) => (_ctx.closeSuccessMessages(successMessage))
          }, null, 8, _hoisted_21)
        ]))
      }), 128))
    ])
  ], 64))
}